import axiosClient from "./axiosClient"

const utilApi = {
    getListProvince(id) {
        const url = `/public/provinces?provinceId=${id}`
        return axiosClient.get(url);
    }
}

export default utilApi